import { render, staticRenderFns } from "./mailTo.vue?vue&type=template&id=56853da0&scoped=true&viewBox=0%200%2022.001%2018"
import script from "./mailTo.vue?vue&type=script&lang=js"
export * from "./mailTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56853da0",
  null
  
)

export default component.exports